import "@php-wasm/node-polyfills";
const E = "playground-log", f = (e, ...r) => {
  M.dispatchEvent(
    new CustomEvent(E, {
      detail: {
        log: e,
        args: r
      }
    })
  );
}, w = (e, ...r) => {
  switch (typeof e.message == "string" ? Reflect.set(e, "message", g(e.message)) : e.message.message && typeof e.message.message == "string" && Reflect.set(
    e.message,
    "message",
    g(e.message.message)
  ), e.severity) {
    case t.Debug:
      console.debug(e.message, ...r);
      break;
    case t.Info:
      console.info(e.message, ...r);
      break;
    case t.Warn:
      console.warn(e.message, ...r);
      break;
    case t.Error:
      console.error(e.message, ...r);
      break;
    case t.Fatal:
      console.error(e.message, ...r);
      break;
    default:
      console.log(e.message, ...r);
  }
}, L = (e) => e instanceof Error ? [e.message, e.stack].join(`
`) : JSON.stringify(e, null, 2), d = [], m = (e) => {
  d.push(e);
}, c = (e) => {
  if (e.raw === !0)
    m(e.message);
  else {
    const r = S(
      typeof e.message == "object" ? L(e.message) : e.message,
      e.severity,
      e.prefix ?? a.JS
    );
    m(r);
  }
}, $ = () => {
  d.length = 0;
};
let i = 0;
const u = "/wordpress/wp-content/debug.log", b = async (e) => await e.fileExists(u) ? await e.readFileAsText(u) : "", k = (e, r) => {
  r.addEventListener("request.end", async () => {
    const s = await b(r);
    if (s.length > i) {
      const o = s.substring(i);
      e.logMessage({
        message: o,
        severity: t.Log,
        raw: !0
      }), i = s.length;
    }
  }), r.addEventListener("request.error", (s) => {
    s = s, s.error && (e.logMessage({
      message: `${s.error.message} ${s.error.stack}`,
      severity: t.Fatal,
      prefix: s.source === "request" ? a.PHP : a.WASM
    }), e.dispatchEvent(
      new CustomEvent(e.fatalErrorEvent, {
        detail: {
          logs: e.getLogs(),
          source: s.source
        }
      })
    ));
  });
}, t = {
  Fatal: { name: "fatal", level: 0 },
  Error: { name: "error", level: 1 },
  Warn: { name: "warn", level: 2 },
  Log: { name: "log", level: 3 },
  Info: { name: "info", level: 4 },
  Debug: { name: "debug", level: 5 }
}, a = {
  WASM: "Wasm Crash",
  PHP: "PHP",
  JS: "JavaScript"
};
class P extends EventTarget {
  // constructor
  constructor(r = []) {
    super(), this.fatalErrorEvent = "playground-fatal-error", this.severity = t.Info, this.handlers = r;
  }
  /**
   * Get all logs.
   * @returns string[]
   */
  getLogs() {
    return this.handlers.includes(c) ? [...d] : (this.error(`Logs aren't stored because the logToMemory handler isn't registered.
				If you're using a custom logger instance, make sure to register logToMemory handler.
			`), []);
  }
  /**
   * Log message with severity.
   *
   * @param log Log
   * @param args any
   */
  logMessage(r, ...s) {
    const o = {
      ...r,
      severity: r.severity ?? t.Log
    };
    for (const n of this.handlers)
      o.severity.level <= this.severity.level && n(o, ...s);
  }
  /**
   * Filter message based on severity
   * @param severity LogSeverity
   */
  setSeverityFilterLevel(r) {
    this.severity = r;
  }
  /**
   * Log message
   *
   * @param message any
   * @param args any
   */
  log(r, ...s) {
    this.logMessage(
      {
        message: r,
        severity: t.Log,
        prefix: a.JS,
        raw: !1
      },
      ...s
    );
  }
  /**
   * Log debug message
   *
   * @param message any
   * @param args any
   */
  debug(r, ...s) {
    this.logMessage(
      {
        message: r,
        severity: t.Debug,
        prefix: a.JS,
        raw: !1
      },
      ...s
    );
  }
  /**
   * Log info message
   *
   * @param message any
   * @param args any
   */
  info(r, ...s) {
    this.logMessage(
      {
        message: r,
        severity: t.Info,
        prefix: a.JS,
        raw: !1
      },
      ...s
    );
  }
  /**
   * Log warning message
   *
   * @param message any
   * @param args any
   */
  warn(r, ...s) {
    this.logMessage(
      {
        message: r,
        severity: t.Warn,
        prefix: a.JS,
        raw: !1
      },
      ...s
    );
  }
  /**
   * Log error message
   *
   * @param message any
   * @param args any
   */
  error(r, ...s) {
    this.logMessage(
      {
        message: r,
        severity: t.Error,
        prefix: a.JS,
        raw: !1
      },
      ...s
    );
  }
}
const T = () => {
  try {
    if (process.env.NODE_ENV === "test")
      return [c, f];
  } catch {
  }
  return [c, w, f];
}, M = new P(T()), g = (e) => e.replace(/\t/g, ""), S = (e, r, s) => {
  const o = /* @__PURE__ */ new Date(), n = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC"
  }).format(o).replace(/ /g, "-"), p = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: !1,
    timeZone: "UTC",
    timeZoneName: "short"
  }).format(o), v = n + " " + p;
  return e = g(e), `[${v}] ${s} ${r.name}: ${e}`;
}, D = (e, r) => {
  e.addEventListener(e.fatalErrorEvent, r);
}, x = (e, r) => {
  e.logMessage({
    message: `${r.message} in ${r.filename} on line ${r.lineno}:${r.colno}`,
    severity: t.Error
  });
}, h = (e, r) => {
  if (!(r != null && r.reason))
    return;
  const s = (r == null ? void 0 : r.reason.stack) ?? r.reason;
  e.logMessage({
    message: s,
    severity: t.Error
  });
};
let l = 0;
const O = (e) => {
  navigator.serviceWorker.addEventListener("message", (r) => {
    var s, o, n;
    ((s = r.data) == null ? void 0 : s.numberOfOpenPlaygroundTabs) !== void 0 && l !== ((o = r.data) == null ? void 0 : o.numberOfOpenPlaygroundTabs) && (l = (n = r.data) == null ? void 0 : n.numberOfOpenPlaygroundTabs, e.debug(
      `Number of open Playground tabs is: ${l}`
    ));
  });
};
let y = !1;
const J = (e) => {
  y || (O(e), !(typeof window > "u") && (window.addEventListener(
    "error",
    (r) => x(e, r)
  ), window.addEventListener(
    "unhandledrejection",
    (r) => h(e, r)
  ), window.addEventListener(
    "rejectionhandled",
    (r) => h(e, r)
  ), y = !0));
}, C = (e) => {
  e.addEventListener("activate", () => {
    e.clients.matchAll().then((r) => {
      const s = {
        numberOfOpenPlaygroundTabs: r.filter(
          // Only count top-level frames to get the number of tabs.
          (o) => o.frameType === "top-level"
        ).length
      };
      for (const o of r)
        o.postMessage(s);
    });
  });
};
export {
  a as LogPrefix,
  t as LogSeverity,
  P as Logger,
  D as addCrashListener,
  $ as clearMemoryLogs,
  k as collectPhpLogs,
  J as collectWindowErrors,
  u as errorLogPath,
  S as formatLogEntry,
  f as logEvent,
  E as logEventType,
  w as logToConsole,
  c as logToMemory,
  M as logger,
  d as logs,
  g as prepareLogMessage,
  C as reportServiceWorkerMetrics
};
//# sourceMappingURL=index.js.map
